/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from 'theme-ui';
import { keyframes } from '@emotion/core';
import styled from '@emotion/styled';
const bounceIn = () => keyframes `
  0% {
    transform: scale(0);
  }

  100% {
    transform: scale(1);
  }
`;
const Wrapper = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
`;
const Dot = styled(({ duration, ...rest }) => jsx("div", Object.assign({}, rest))) `
  animation: ${bounceIn} ${props => props.duration}ms ease alternate infinite;
  &:nth-of-type(1) {
    animation-delay: ${props => (props.duration / 5) * 0}ms;
  }
  &:nth-of-type(2) {
    animation-delay: ${props => (props.duration / 5) * 1}ms;
  }
  &:nth-of-type(3) {
    animation-delay: ${props => (props.duration / 5) * 2}ms;
  }
`;
const ThreeDotsLoader = ({ size = '10px', duration = 500, gap = '5px', color = 'greenCTA' }) => {
    return (jsx(Wrapper, null, [0, 0, 0].map((_, i) => (jsx(Dot, { key: i.toString(), sx: {
            bg: color,
            width: size,
            height: size,
            borderRadius: '50%',
            margin: `0px ${gap}`
        }, duration: duration })))));
};
export default ThreeDotsLoader;
//# sourceMappingURL=three-dots-loader.js.map